import { StartOfWeekOptions } from "date-fns";

import TimelineAction from "@app/enum/TimelineAction";

export const MAX_SELECTED_USERS = 5;

export const WEEK_OPTIONS = { weekStartsOn: 1 } satisfies StartOfWeekOptions;

// Field View switches from individual check-in pins to the heatmap once the number of displayable
// check-in pins across the selected reps reaches this value (TART-27199). The comparison in
// getIsAboveHeatmapThreshold is inclusive, so this exact count already shows the heatmap.
export const HEATMAP_CHECKIN_THRESHOLD = 100;

// Timeline actions Field View surfaces as feed rows (drawn by EventItem). Unlike the dashboard's set,
// Field View also includes app-start / find-me location pings. Keep in sync with EventItem's switch.
export const FIELD_VIEW_TIMELINE_ACTIONS: ReadonlySet<TimelineAction> = new Set([
  TimelineAction.ACTIVITY_ASSIGNED,
  TimelineAction.ACTIVITY_COMPLETED,
  TimelineAction.APP_START,
  TimelineAction.FILE_ADDED,
  TimelineAction.FIND_ME,
  TimelineAction.MENTION,
  TimelineAction.NOTE_ADDED,
  TimelineAction.RECORD_ADDED,
  TimelineAction.RECORD_UPDATED,
  TimelineAction.ROUTE_CREATED,
]);
